// import logo from './logo.svg';
import './App.css';
import './components/css/styleToAll.css';

import Home from './components/Home';
import Custmors from './components/Custmers';
// import Leading from './components/Leading';
// import Building from './components/Building';
import CaseStudy from './components/CaseStudy';
// import Developement from './components/Developement';
import Advertising from './components/Advertising';
import ContactPage from './components/routingpages/Contactpage'
import AboutUs from './components/routingpages/AboutUS'
import { useState } from 'react';
import SimpleSlider from './components/SimbleSlider';
//mui
// import { ThemeProvider,} from '@mui/material/styles';
import { ThemeProvider, createTheme } from '@mui/material/styles';


import CssBaseline from '@mui/material/CssBaseline';


import { BrowserRouter ,Routes ,Route} from 'react-router-dom';





function App() {

  const [myMode,setMymode] = useState("light");

  const darkTheme = createTheme({
    palette: {
      mode: myMode,
    },
  });

//   return (
//     <ThemeProvider theme={darkTheme}>
//        <CssBaseline />
//     <div className ="container">
//     <Navbar setMymode={setMymode}/>
//     {/* <NavbarBootstrap setMymode={setMymode}/> */}
//     <Header/>
//     <AboutUs/>
//     <SimpleSlider/>
//     {/* <Leading/>     */}
//     <Custmors/>
//     <CaseStudy/>
//     {/* <Building/> */}
//     {/* <Developement/> */}
//     <Advertising/>
//     <ContactPage/>
//     <Footer/>
//     </div>
//       </ThemeProvider>
  
    
//   );
// }


  return (
  
      <ThemeProvider theme={darkTheme}>
       <CssBaseline />
    <div className ="container">

<BrowserRouter>
<Routes>
    <Route path='/' element={<Home/>} />
    <Route path='/about-us' element={<AboutUs/>} />
    <Route path='/services' element={<SimpleSlider/>} />
    <Route path='/our-team' element={<Custmors/>}/>
    <Route path='/case-study' element={<CaseStudy/>}/>
    <Route path='/hire' element={     <Advertising/>} />
    <Route path='/contact-us' element={    <ContactPage/>} />
</Routes>
</BrowserRouter>
   </div>
      </ThemeProvider>
  );
}

export default App;
